import React, { useEffect, useState } from 'react';
import { ModalPattern } from '../../components';
import {
  useGetPerformanceTriangleObjectives,
  usePostPerformanceTriangleObjectives,
} from '../../api/dashboardAnalytics';
import DashboardObjectivesForm from './DashboardObjectives/DashboardObjectivesForm';

export const DashboardSettingsModal = ({ onCancel, onConfirm }) => {
  const [formValues, setFormValues] = useState({
    holdTime: '',
    waste: '',
    stockout: '',
  });

  const [formErrors, setFormErrors] = useState({
    holdTime: null,
    waste: null,
    stockout: null,
  });

  const { data: initialObjectives, isFetching } = useGetPerformanceTriangleObjectives();
  const [postObjectives] = usePostPerformanceTriangleObjectives();

  useEffect(() => {
    if (initialObjectives) {
      setFormValues({
        holdTime: initialObjectives.targetHoldTimeSeconds,
        stockout: initialObjectives.targetStockoutTimeSeconds / 60,
        waste: initialObjectives.targetWastePercentage,
      });
    }
  }, [initialObjectives]);

  const body = (
    <DashboardObjectivesForm
      formValues={formValues}
      setFormValues={setFormValues}
      formErrors={formErrors}
      setFormErrors={setFormErrors}
      loading={isFetching}
    />
  );

  return (
    <ModalPattern
      size={'sm'}
      title="Settings"
      onCancel={() => {
        onCancel();
      }}
      onConfirm={() => {
        const hasObjectiveErrors = Object.values(formErrors).some(item => item !== null);

        if (!hasObjectiveErrors) {
          const newObjectives = {
            targetHoldTimeSeconds: Number(formValues.holdTime),
            targetStockoutTimeSeconds: formValues.stockout * 60,
            targetWastePercentage: Number(formValues.waste),
          };

          if (
            newObjectives.targetHoldTimeSeconds !== initialObjectives.targetHoldTimeSeconds ||
            newObjectives.targetStockoutTimeSeconds !== initialObjectives.targetStockoutTimeSeconds ||
            newObjectives.targetWastePercentage !== initialObjectives.targetWastePercentage
          ) {
            postObjectives({ data: newObjectives });
          }
        }

        onConfirm();
      }}
      modalBody={body}
    />
  );
};
